import React from 'react'
import Component from '../common/Component'
import AccidentBenefitsSetComponent from './AccidentBenefitsSetComponent'
import { benefitNames } from './accidentFields'
import BenefitsSetForm from '../BenefitsSet/BenefitsSetForm'

export default class AccidentBenefitsSetForm extends Component {
  render() {
    return (
      <BenefitsSetForm
        benefitNames={benefitNames}
        benefitsSetComponent={AccidentBenefitsSetComponent}
        productLine="Accident"
        {...this.props}
      />
    )
  }
}
